// PanelErrorBoundary.jsx — (شبكة أمان) حدّ خطأ لكل لوحة، لا حدّ عالمي واحد.
// انهيار العرض داخل لوحة واحدة يُظهر رسالة ودّية + زر إعادة محاولة، بينما
// يبقى هيكل التطبيق (التنقّل/الرأس) خارج الحد حيًّا — فلا تُبيَّض الشاشة كلها.
import React from "react";
import { reportClientError } from "../lib/clientErrorReporter";

export class PanelErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, code: "" };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[PanelErrorBoundary]", error, info);
    const code = reportClientError({ error, componentStack: info?.componentStack || "", kind: "boundary" });
    this.setState({ code });
  }

  handleRetry = () => this.setState({ hasError: false, code: "" });

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="panel-error-boundary"
          dir="rtl"
          style={{
            margin: 16,
            padding: 24,
            borderRadius: 16,
            background: "#FFF7ED",
            border: "1px solid #FED7AA",
            textAlign: "center",
            fontFamily: "Tajawal, sans-serif",
          }}
        >
          <div style={{ fontSize: 28, marginBottom: 8 }} aria-hidden>
            ⚠️
          </div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#9A3412", marginBottom: 6 }}>
            تعذّر عرض هذا الجزء
          </div>
          <p style={{ fontSize: 13, color: "#B45309", lineHeight: 1.8, marginBottom: 16 }}>
            حدث خطأ غير متوقع أثناء عرض هذا القسم. بقية التطبيق تعمل بشكل طبيعي —
            يمكنك إعادة المحاولة أو الانتقال إلى قسم آخر.
          </p>
          {this.state.code && (
            <div data-testid="panel-error-code" style={{ fontSize: 12, color: "#9A3412", marginBottom: 12 }}>
              رمز الخطأ: <code style={{ fontWeight: 800, letterSpacing: 1 }}>{this.state.code}</code>
            </div>
          )}
          <button
            data-testid="panel-error-retry"
            onClick={this.handleRetry}
            style={{
              padding: "10px 20px",
              borderRadius: 999,
              border: "none",
              background: "#EA580C",
              color: "#FFF",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            ↻ إعادة المحاولة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PanelErrorBoundary;
